import React from "react";
import { Foot } from "./Styled-Footer";
import "./footer.css";

export default function Footer() {
  return (
    <Foot>
      <section id="section-1">
        <div id="div-1">
          <div>
            <h1>Shop Non-Stop on Meesho</h1>
            <p>
              Trusted by more than 1 Crore Indians
              <br /> Cash on Delivery | Free Delivery
            </p>
            <button>
              <img
                src="https://www.svgrepo.com/show/131985/google-play.svg"
                alt=""
              />
              <span>GET IT ON</span>
              <p>Google Play</p>
            </button>
            <button>
              <img src="https://www.svgrepo.com/show/7385/apple.svg" alt="" />
              <span>Download on the</span>
              <p>App Store</p>
            </button>
          </div>
        </div>
        <div>
          <div>
            <p>Careers</p>
            <p>Become a Supplier</p>
            <p>Our Influencer Program</p>
            <p>Hall of Fame</p>
          </div>
          <div>
            <p>Legal and Policies</p>
            <p>Meesho Tech Blog</p>
            <p>Notices and Returns</p>
          </div>
        </div>
        <div>
          <div id="icons">
            <h3>Reach out to us</h3>
            <img
              src="https://www.svgrepo.com/show/157818/facebook.svg"
              alt=""
            />
            <img
              src="https://www.svgrepo.com/show/157806/instagram.svg"
              alt=""
            />
            <img src="https://www.svgrepo.com/show/97434/twitter.svg" alt="" />
            <img src="https://www.svgrepo.com/show/57068/linkedin.svg" alt="" />
            <img src="https://www.svgrepo.com/show/103204/youtube.svg" alt="" />
          </div>
          <div>
            <h3>Contact Us</h3>
            <p>
              Fashnear Technologies Private Limited, CIN: U74900KA2015PTC082263
              06-105-B, 06-102, (138 Wu) Vaishnavi Signature, No. 78/9, Outer
              Ring Road, Bellandur, Varthur Hobli, Bengaluru-560103, Karnataka,
              India E-mail address: query@meesho.com © 2015-2022 Meesho.com
            </p>
          </div>
        </div>
      </section>
      <section id="section-2">
        <h4>More About Meesho</h4>
        <hr />
        <h6>Meesho: Online Shopping Made Affordable</h6>
        <p>
          There are lots of reasons to shop online! It can be fun and
          convenient. And if you are looking for budget-friendly online
          shopping, then you are at the right place. Meesho offers top-quality
          products at rock bottom prices, allowing you to shop to your heart’s
          content without any budget restraints.
        </p>
        <h6>Explore a Wide Range of Products Across All Categories</h6>
        <p>
          At Meesho, you have over 50 lakh items to choose from including a wide
          range of apparel, cosmetics, household items, and many more
          categories! We have 650+ product categories and thousands of
          handpicked products that are the latest on the market. Whether you're
          looking for a new outfit, a gift for a special someone, or just some
          household items for everyday use, you will find everything you need at
          the lowest prices on Meesho.
        </p>
        <h6>
          The Best Of Women's Fashion at Your Fingertips Western Wear for Women
        </h6>
        <p>
          Shopping for Western wear for women at Meesho is always economical as
          we only bring you the latest styles at wholesale prices. Affordability
          without compromising on the style quotient is possible at Meesho where
          you will find a huge range of casual, formal, and partywear dresses,
          <span> gowns</span>, <span>jeans</span>, <span>tops</span>,{" "}
          <span>T-shirts</span>, <span>skirts</span>, and more. You can buy all
          the trending outfits you want along with funky jewellery and
          accessories at reasonable prices
        </p>
        <h6>Women’s Ethnic Wear Collection</h6>
        <p>
          No matter what occasion or season, you’ll find the perfect outfits in
          our latest women’s ethnic wear collection. From{" "}
          <span>traditional Sarees</span> and Blouses to{" "}
          <span>classy Suits</span>, and
          <span> casual Kurtis</span>, we have it all. Picking the perfect
          outfit for your next wedding party or festive celebration is
          effortless when you shop with us! Check out our stunning collection of
          accessories, footwear jewellery sets, and earrings to go with your
          ethnic look.
        </p>
        <h6>Jewellery, Accessories, and Footwear</h6>
        <p>
          It's true that accessories make or break your look! When you're
          getting dressed, it's good to always have some accessories, footwear,
          and <span>jewellery</span> that compliment your outfit. But you don't
          need to shell out too much money to get the latest designs anymore.
          <br /> With Meesho, you can buy different types of accessories like
          bags, watches, stoles, necklaces, earrings, bracelets, and more at
          affordable prices.
        </p>
        <h6>
          The Latest Collection of Men’s Fashion Just a Click Away Western Wear
          for Men
        </h6>
        <p>
          From formal wear like suits, trousers, <span>men’s shirts</span>, and
          coats to casual wear like polos and button-down shirts, we have the
          latest designs in every category. Our selection of menswear is sure to
          please even the pickiest male customers. These products come in a
          range of sizes &amp; colors to fit your body &amp; style.
        </p>
        <h6>Men's Ethnic Wear</h6>
        <p>
          Do you need a new Sherwani? Are you heading to a wedding and want to
          look your best? If you answered yes, look no further than our latest
          men’s ethnic wear collection! Whether you want a Kurta set, Pajamas,
          Sherwani set, or any other Indian attire, we have an array of
          budget-friendly styles that are sure to fit your needs.
        </p>
        <h6>Accessories, Footwear, and more</h6>
        <p>
          In our collection of accessories for men, you will find all sorts of
          items like watches, keychains, wallets, and more! Our footwear
          selection is constantly updated with the latest trends in shoes so
          that you never have to miss out on anything fashionable. If you're
          looking for some casual and comfortable sneakers, sports shoes, or
          smart and formal shoes for the workplace, we’re sure to have just the
          thing that will match your requirements.{" "}
        </p>
        <h6>Best Quality Beauty Products at Low Prices</h6>
        <p>
          We know you don't have time to run around town trying to find the best
          makeup or the best products for your skincare routine. This is why we
          sell everything from lipsticks, foundations, compacts to daily use
          <span> face wash</span>, <span>moisturizers</span>,{" "}
          <span>sunscreens</span>, and everything in between. Browse through our
          enormous collection of products to find the best skincare and makeup
          products for your needs.{" "}
        </p>
        <h6>Trendy Kidswear for Your Little Ones</h6>
        <p>
          If you're looking to buy some new outfits or cute accessories for your
          kids, be sure to check out our kidswear collection. You will find the
          latest kids’ rompers, skirts, tops,dresses, and frocks for girls to
          adorable clothing sets, jeans, shorts,topwear, etc for your boys. We
          also have ethnic wear and accessories for kids of all ages. Our baby
          care collection includes everything you might need to take care of
          your little one.
        </p>
        <h6>
          An Exciting Range of Home Essentials, Kitchen Products, Electronics,
          and more Electronics and Accessories
        </h6>
        <p>
          If you are looking for affordable gadgets and everyday essentials like
          <span> chargers</span>, <span>headphones</span>,{" "}
          <span>data cables</span>, etc, we have a huge selection you can
          browse. With great deals and sales happening all the time, your wallet
          will be happy, too. Check out the deals we've picked especially for
          you, and you'll find great gifts for everyone on your list. Less is
          more with our <span>electronic items</span>, and you'll feel the
          savings, too.
        </p>
        <h6>Kitchenware</h6>
        <p>
          We carry all of the essentials that you'll need to spice up your
          kitchen. You'll have a wide variety of utensils and cookware to choose
          from, so you could pick something that fits your needs and your
          budget. We also have kitchen accessories like storage{" "}
          <span>jars and containers</span>, small appliances like{" "}
          <span>juicers</span>,<span>mixers</span>,{" "}
          <span>induction cooktops</span> that will make your cooking a whole
          lot easier! We have a wide range of serveware and cutlery including
          glasses, dinner sets, knives to choose from, so you'll be able to find
          what you need at a great price.
        </p>
        <h6>Home Essentials</h6>
        <p>
          We know how crucial it is to give your home a makeover every once in a
          while. However, it is important to ensure that you're investing your
          money in the right products. With Meesho, you'll find the best prices
          and the best selections, where we have home furnishing items like
          bedsheets, <span>curtains</span>, <span>blankets</span>, etc in every
          color you could possibly want and we're always making sure that you
          can get your hands on the best home decor items, with the biggest
          discounts. So be sure to check out our home decor section.{" "}
        </p>
        <h6>Sports, Health &amp; Fitness</h6>
        <p>
          It is now more important than ever to keep your body fit and healthy.
          So start your fitness journey with Meesho. Check out our selection of
          fitness equipment available at wholesale prices. You will find
          everything from sportswear to yoga mats to exercise equipment for your
          home workouts like <span>dumbbell sets</span>, resistance bands, etc.{" "}
        </p>
        <h6>Stationery Collection</h6>
        <p>
          You do not need to spend a lot of money on buying new stationery. We
          have a large collection of stationery items for various uses and the
          usage is for everyone, whether you are a student or a working
          professional. We have a wide variety of beautiful notebooks, diaries,
          pens, pencils, postcards, sticky notes, and much more.{" "}
        </p>
        <h6>Use Meesho App for The Best Online Shopping Experience</h6>
        <p>
          Now you can shop for anything your heart desires from the comfort of
          your home. Make sure to download the Meesho app to have a smooth and
          enjoyable shopping experience. You can even share products you like
          with your friends on social media in just seconds. If you're trying to
          save time and get the best deals, downloading the best app for
          shopping is the way to go!
          <br />
          Don't Miss Out! Download Meesho App Now
        </p>
        <h6>Become a Reseller: Start Making Money In Three Simple Steps</h6>
        <p>
          Now that you've been introduced to Meesho's product categories, it's
          time to learn about our other offerings. Besides shopping for yourself
          on the platform, you can also become an entrepreneur and earn cash for
          what you do best. Here’s how you can begin your entrepreneurial
          journey. <br />
          Browse: Use your phone to register a new account, or log in to an
          existing one at the Meesho app or website. You can read through our
          catalog and select products that you want at wholesale rates!
          <br />
          Share: You can simply send catalogs and product images over Whatsapp,
          Facebook, or Instagram to your contacts in a single click using the
          share option. Earn: Once you have shared the catalogs with your
          prospective customers, you'll soon start getting order requests and
          inquiries. You can quote product prices with an added margin, which
          will include a profit for you. Once an order has been placed and paid
          for, you can place the orders yourself using our established processes
          that ensure they get delivered to your waiting customers on time.
          <br />
          Start Your Online Shopping Journey with Meesho Today You can rest
          assured that we only deliver the best products to you. You have
          multiple payment options including debit and credit cards, UPI, and
          Cash on Delivery. If you're not happy with the quality of your
          product, send it back and get a full refund without any hassle. Want
          to learn more? Feel free to send us an email at query@meesho.com. You
          can also reach out to us on Facebook, Instagram, or Twitter. We're
          here to help you!
        </p>
        <h4>Online Shopping</h4>
        <div id="pink-para">
          <h6>Home &amp; Living</h6>
          <p>
            Curtains | Cushion Covers | Sofa Covers | Bedsheets | Bedding Sets |
            Pillows | Mattress Protectors | Duvet Covers | Blankets | Quilts |
            Doormats | Carpets | Bean Bags | Diwan Sets | Cushions | Face Towels
            | Towels | Trays | Coasters
          </p>
          <h6>Men Ethnicwear</h6>
          <p>
            Men Kurtas | Men Ethnic Jackets | Men Velvet Sherwanis | Men Dhotis
          </p>
          <h6>Women Western Wear</h6>
          <p>
            Tops | Dresses | Women Tshirts | Gowns | Skirts | Women Trousers |
            Women Jeans | Women Sweatshirts | Shrugs | Capris | Women Sweaters |
            Cardigans | Palazzos | Leggings | Tights | Jumpsuits | Kaftans |
            Maternity Wear | Women Shorts | Jeggings | Nightdress | Women Night
            Suits | Women Briefs | Lingerie Sets | Bra | Stockings | Camisoles |
            Bathrobes | Babydolls | Women Shapewear | Women Pyjamas | Swimwear |
            Women Jackets | Women Thermal Set
          </p>
          <h6>Women Ethnicwear</h6>
          <p>
            Sarees | Blouses | Kurtis | Lehengas | Sharara | Dupattas |
            Petticoats | Abaya | Women Kurta Sets | Shawls | Blouse Piece |
            Kurti Fabric | Semi Stitched Suits
          </p>
          <h6>Women Footwear</h6>
          <p>
            Sandals | Women Slippers | Women Casual Shoes | Women Flats | Women
            Floaters | Bellies &amp; Ballerinas | Juttis &amp; Mojaris
          </p>
          <h6>Women Accessories</h6>
          <p>
            Women Watches | Mangalsutras | Rings | Handbags | Umbrellas | Women
            Sunglasses | Jewellery Set | Women Slingbags | Trolley Bags | Hijabs
            | Socks | Clutches | Hair Accessories | Maangtika | Pouches | Duffle
            Bags | Handkerchiefs | Bindis | Waist Bags | Rucksacks | Briefcases
            | Small Travel Bags | Potlis | Nosepins | Bangles &amp; Bracelets |
            Anklets &amp; Toe Rings | Earrings &amp; Studs | Necklaces &amp;
            Chains | Scarves &amp; Stoles
          </p>
          <h6>Electronics &amp; Accessories</h6>
          <p>
            Smart watches | Bluetooth Headphones | Bluetooth Speakers |
            Bluetooth Earphones | Wired Headphones | CCTV Cameras | Camera
            Tripod | Keyboard | Laptop Bags | Mouse | Laptop Skin | Pen Drives |
            Earphones | Power Banks | Headphones | Data Cables | Mobile Cases
            &amp; Covers | Mobile Holders | Mobile Chargers | Speakers | Diwali
            Lightings | Microphone | Memory Cards | Digital Photo Frames |
            Dongle | VR Box
          </p>
          <h6>Men Western Wear</h6>
          <p>
            Men Shorts | Men Jeans | Men Trousers | Men Active Shorts | Men
            Track Pants | Men Tshirts | Men Shirts | Men Sweatshirts | Men
            Jackets | Men Blazers | Men Sweaters | Men Tracksuits | Men Shirt
            Fabric | Men Gym vests | Men Vests | Men Briefs | Men Trunks | Men
            Thermals
          </p>
          <h6>Men Footwear</h6>
          <p>
            Men Sports Shoes | Men Sandals | Men Formal Shoes | Men Casual Shoes
            | Men Flip Flops | Men Loafers
          </p>
          <h6>Men Accessories</h6>
          <p>
            Men Watches | Men Jewellery | Men Caps | Men Bracelets | Men
            Sunglasses | Men Trolley Bags | Ties | Wallets | Men Keychains | Men
            Socks | Men Belts | Men Bandana | Men Scarves | Men Handkerchiefs |
            Men Mufflers | Brooches | Men Waist Bags | Men Wrist Bands | Men
            Rucksacks | Men Crossbody Bags | Men Shirt Studs
          </p>
          <h6>Kids</h6>
          <p>
            Kids Lunch Boxes | Kids Ethnic Jackets | Kids Blazers | Kids Rompers
            | Kids Kurtis &amp; Kurtas | Kids Salwar Suit Sets | Kids Ethnic
            Gowns | Kids Dresses | Kids Jumpsuits
          </p>
          <h6>Baby</h6>
          <p>
            Baby Pillows | Baby Towels | Baby Hanging Cradle | Baby Sleeping Bag
            | Baby Blanket
          </p>
          <h6>Home &amp; Kitchen</h6>
          <p>
            Toaster | Mixer Grinder | Cookers | Juicer | Food Processors | Roti
            Maker | Sandwich Maker | Kettles | Hand Blender | Table Cover |
            Napkins Holder | Kitchen Mat | Kitchen Towel | Aprons | Kitchen
            Gloves | Racks &amp; Holders | Spice Racks | Jars &amp; Container |
            Water Bottles | Thermos &amp; Flasks | Lunch Boxes | Salt &amp;
            Pepper Shakers | Knives | Food Strainers | Choppers | Mashers |
            Graters | Cutlery | Chopping Boards | Kitchen Scissors | Ice Cube
            Trays | Juicer | Measuring Cups | Tongs | Ice Cream Scoops | Funnels
            | Trivets
          </p>
          <h6>Personal Care &amp; Wellness</h6>
          <p>
            Trimmers | Makeup Kits | Hair Straighteners | Hair Dryers | Hair
            Care | Oral Care | Beard Oil | Deodorants | Kajal | Soap | Primer |
            Bb Cream | Body Scrub | Hair Oil | Talcum Powder | Foundation |
            Compact | Nail Polish | Lip Balm | Moisturizer | Eyeliner |
            Highlighter | Lipstick | Shopee
          </p>
        </div>
      </section>
    </Foot>
  );
}
